"use client";
import type { ReactNode } from "react";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ModalTypes } from "@lib/enums/ModalTypes";
import type { ButtonProps } from "@ecco/ui/button";
import { Button } from "@ecco/ui/button";
import { guideDropdownItemAppearance, guideTriggerAppearance } from "./SizeGuide.styles";

interface GuideProps {
    onOpen: () => void;
    children: ReactNode;
}

const DropdownItemGuide = ({ onOpen, children }: GuideProps) => (
    <Button
        type="button"
        onClick={onOpen}
        {...(guideDropdownItemAppearance as unknown as ButtonProps)}
    >
        {children}
    </Button>
);

const TriggerGuide = ({ onOpen, children }: GuideProps) => (
    <Button type="button" onClick={onOpen} {...(guideTriggerAppearance as unknown as ButtonProps)}>
        {children}
    </Button>
);

interface SizeGuideProps {
    gender?: string;
    targetGroup?: string;
    materialGroup?: string;
    isToolbar?: boolean;
    isFootwear?: boolean;
    type?: string;
}

export const SizeGuide = ({
    gender,
    isToolbar = false,
    targetGroup,
    materialGroup,
    isFootwear,
    type,
}: SizeGuideProps) => {
    const { getMultiple } = useMicrocopy();
    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.guide.socks,
            CommonCMS.guide.belts,
            CommonCMS.guide.laces,
            CommonCMS.guide.kids,
            CommonCMS.size.guideModalTitle,
        ]);
    })();
    const isSocks = materialGroup === microcopies[CommonCMS.guide.socks];
    const isBelts = materialGroup === microcopies[CommonCMS.guide.belts];
    const isLaces = materialGroup === microcopies[CommonCMS.guide.laces];
    const forKids = targetGroup === microcopies[CommonCMS.guide.kids];
    const { showModal } = useGlobalModalContext();

    const openGuide = () =>
        showModal(type, {
            gender,
            isFootwear,
            isSocks,
            forKids,
            targetGroup,
            materialGroup,
        });

    if (type === ModalTypes.sizeGuide && !(isSocks || isBelts || isLaces || isFootwear || forKids))
        return null;

    return isToolbar ? (
        <DropdownItemGuide onOpen={openGuide}>
            {microcopies[CommonCMS.size.guideModalTitle]}
        </DropdownItemGuide>
    ) : (
        <TriggerGuide onOpen={openGuide}>
            {microcopies[CommonCMS.size.guideModalTitle]}
        </TriggerGuide>
    );
};
